import type { HighlightType } from '@/types/profile';
import { getHighlightReactKey } from '@/utils/highlightIdentity';

type SlideKeyInput = Pick<
    HighlightType,
    | 'typeCd'
    | 'mediaUrl'
    | 'url'
    | 'description'
    | 'coverArtUrl'
    | 'imagePath'
    | 'jamBoardPinColor'
    | 'jamBoardPinId'
>;

/**
 * Stable key so deleting or prepending a slide does not remount the others.
 * Index is only used when the slide has no image path or media url.
 */
export function getHighlightCarouselSlideKey(slide: SlideKeyInput, index: number): string {
    if (slide.typeCd === 'JB' && slide.jamBoardPinId) {
        return `jb:${slide.jamBoardPinId}`;
    }
    if (slide.typeCd === 'JB') {
        return `jb:${slide.coverArtUrl || ''}:${slide.description || ''}:${slide.jamBoardPinColor || ''}:${index}`;
    }
    return getHighlightReactKey(slide as HighlightType, index);
}
